/* ============================================================
   boost-cart.js  (v7)
   Point d'entrée unique du panier Boost.

   Gère automatiquement :
   1) Liens vers /cart              -> ouvre le tiroir
   2) Formulaires POST /cart/add    -> ajout AJAX
   3) Liens GET /cart/add?id=...    -> ajout AJAX
   4) Après ajout : notification / tiroir / les deux (selon les réglages)

   Perf : l'ajout ne demande PAS le rendu des sections. La notification
   s'affiche donc dès la réponse (~100ms) et le contenu du tiroir est
   rafraîchi en arrière-plan.

   API publique pour les sections custom (fiche produit, bundles, offres...) :
     window.BoostCart.add(items, { trigger, code })  -> Promise
     window.BoostCart.refresh()                      -> resynchronise le tiroir
     window.BoostCart.open() / close()
     window.BoostCart.notify(data) / dismiss()
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */

  function getDrawer() { return document.querySelector('cart-drawer'); }
  function getNotif() { return document.getElementById('BoostCartNotif'); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function addUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }

  function parseUrl(href) {
    try { return new URL(href, window.location.origin); } catch (e) { return null; }
  }
  function isCartUrl(href) {
    var u = parseUrl(href);
    return !!u && /^\/(([a-z]{2}(-[a-z]{2})?)\/)?cart\/?$/i.test(u.pathname);
  }
  function isCartAddUrl(href) {
    var u = parseUrl(href);
    return !!u && /^\/(([a-z]{2}(-[a-z]{2})?)\/)?cart\/add\/?$/i.test(u.pathname);
  }

  /* ---------- Formatage monétaire (logique Shopify) ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function thousands(num, precision, thousand, decimal) {
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var m = fmt.match(placeholder);
    if (!m) return fmt;
    var value;
    switch (m[1]) {
      case 'amount': value = thousands(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = thousands(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ''); break;
      default: value = thousands(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Garde-fou : #cart-icon-bubble ----------
     cart.js du thème de base fait document.getElementById('cart-icon-bubble')
     sans vérifier le résultat. Sur un header custom sans cet id, ça lève
     une exception -> "Une erreur est survenue lors de l'actualisation
     du panier" à chaque changement de quantité. On pose un relais
     invisible, uniquement si l'id est absent. */

  function ensureCartIconBubble() {
    if (document.getElementById('cart-icon-bubble')) return;
    var ph = document.createElement('span');
    ph.id = 'cart-icon-bubble';
    ph.setAttribute('aria-hidden', 'true');
    ph.setAttribute('data-boost-placeholder', '');
    ph.style.display = 'none';
    (document.body || document.documentElement).appendChild(ph);
  }

  /* ---------- Pastille du panier ----------
     Le header peut être custom : on met à jour tout ce qui ressemble à un
     compteur, plus un sélecteur libre défini dans les réglages. */

  function countTargets() {
    var n = getNotif();
    var sels = [
      '[data-boost-cart-count]',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.boost-cart-count'
    ];
    var custom = n && n.dataset.countSelector;
    if (custom) sels.unshift(custom);
    var out = [];
    sels.forEach(function (s) {
      try {
        document.querySelectorAll(s).forEach(function (el) {
          if (el.closest('#BoostCartNotif')) return;              // pas la notif
          if (el.hasAttribute('data-boost-placeholder')) return;  // pas le relais
          if (out.indexOf(el) === -1) out.push(el);
        });
      } catch (e) { /* sélecteur invalide : on ignore */ }
    });
    return out;
  }

  function setCount(count) {
    countTargets().forEach(function (el) {
      el.textContent = count;
      // Certains thèmes masquent la pastille quand le panier est vide
      if (count > 0) el.removeAttribute('hidden');
    });
    // La pastille native n'existe pas si le panier était vide : on la crée
    var bubbleHost = document.getElementById('cart-icon-bubble');
    if (bubbleHost && !bubbleHost.hasAttribute('data-boost-placeholder')
        && !bubbleHost.querySelector('.cart-count-bubble') && count > 0) {
      var b = document.createElement('div');
      b.className = 'cart-count-bubble';
      b.innerHTML = '<span aria-hidden="true">' + count + '</span>';
      bubbleHost.appendChild(b);
    }
  }

  // Rapide : /cart.js est un JSON léger, bien plus rapide qu'un rendu de section
  function refreshCount() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; })
      .catch(function () { /* non bloquant */ });
  }

  /* ---------- Rafraîchissement du tiroir ----------
     On n'utilise PAS drawer.renderContents() : le thème de base y appelle open()
     de force, ce qui ouvrirait le tiroir même en mode notification. */

  function sectionsToRender(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { return drawer.getSectionsToRender(); } catch (e) { /* fallback */ }
    }
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  function innerHTMLOf(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector) || doc.querySelector('.shopify-section');
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function applySections(sections) {
    var drawer = getDrawer();
    if (!drawer || !sections) return;

    sectionsToRender(drawer).forEach(function (section) {
      var target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      var html = sections[section.id];
      if (!target || !html) return;
      // Ne jamais écrire dans le relais invisible : le header custom gère sa pastille
      if (target.hasAttribute && target.hasAttribute('data-boost-placeholder')) return;
      var content = innerHTMLOf(html, section.selector || '#' + section.id);
      if (content !== null) target.innerHTML = content;
    });

    // Le panier n'est plus vide : le thème de base garde la classe sur l'élément parent,
    // qui lui n'est pas re-rendu.
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    // L'overlay a été recréé : on rebranche sa fermeture.
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
  }

  function refresh() {
    var drawer = getDrawer();
    if (!drawer) return Promise.resolve();
    var ids = sectionsToRender(drawer).map(function (s) { return s.id; }).join(',');
    return fetch(window.location.pathname + '?sections=' + ids, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { applySections(sections); })
      .catch(function (e) { console.warn('[boost-cart] refresh:', e); });
  }

  /* ---------- Notification ---------- */

  var notifTimer = null;

  function dismiss() {
    var n = getNotif();
    if (!n) return;
    n.classList.remove('is-open');
    clearTimeout(notifTimer);
    setTimeout(function () { n.hidden = true; }, 300);
  }

  // Shopify peut renvoyer un champ à 0 selon les allocations de remise.
  // On retient le premier prix unitaire réellement non nul.
  function priceOf(it) {
    var c = [];
    if (it.final_price != null) c.push(it.final_price);
    if (it.price != null) c.push(it.price);
    if (it.original_price != null) c.push(it.original_price);
    if (it.quantity) {
      if (it.final_line_price != null) c.push(Math.round(it.final_line_price / it.quantity));
      if (it.original_line_price != null) c.push(Math.round(it.original_line_price / it.quantity));
    }
    var i;
    for (i = 0; i < c.length; i++) { if (c[i] > 0) return c[i]; }   // prix réel
    for (i = 0; i < c.length; i++) { if (c[i] != null) return c[i]; } // article vraiment offert
    return null;
  }

  // Nombre total d'unités réellement ajoutées (somme des quantités de lignes).
  // Ex : offre "2 achetés = 1 offert" = une ligne quantity:3 -> 3.
  function totalQtyOf(data) {
    if (data && Array.isArray(data.items)) {
      return data.items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
    }
    return (data && data.quantity) || 1;
  }

  // Total de ligne RÉEL renvoyé par Shopify (avant remise auto/code non encore
  // chiffrée). Sert de repli quand l'appelant ne fournit pas de prix d'offre.
  function lineTotalOf(data) {
    if (data && Array.isArray(data.items)) {
      var t = 0, ok = false;
      data.items.forEach(function (i) { if (i.final_line_price != null) { t += i.final_line_price; ok = true; } });
      return ok ? t : null;
    }
    if (data && data.final_line_price != null) return data.final_line_price;
    return null;
  }

  // /cart/add.js renvoie soit une ligne unique, soit { items: [...] }
  function firstAdded(data) {
    if (data && Array.isArray(data.items)) {
      var list = data.items;
      // On met en avant le 1er article payant : avec un cadeau offert,
      // une ligne peut être à 0 et ne représente pas l'achat.
      var main = list.find(function (i) { return priceOf(i) > 0; }) || list[0] || {};
      return { item: main, count: list.length };
    }
    return { item: data || {}, count: 1 };
  }

  /**
   * Affiche la notification.
   * @param {Object} data  réponse /cart/add.js
   * @param {Object} [meta] contexte de l'OFFRE réellement choisie, transmis par
   *   la fiche produit : { title, price, comparePrice, quantity, image }.
   *   Quand il est fourni, il prime sur la ligne brute Shopify — c'est ce qui
   *   permet à la notif d'afficher "2 ACHETER = 1 OFFERT !", 40,80 € et ×3.
   */
  function notify(data, meta) {
    var n = getNotif();
    if (!n) return false;
    meta = meta || {};

    var res = firstAdded(data);
    var it = res.item;
    var qty = meta.quantity || totalQtyOf(data) || 1;

    var img = n.querySelector('[data-boost-notif-img]');
    var title = n.querySelector('[data-boost-notif-title]');
    var offer = n.querySelector('[data-boost-notif-offer]');
    var price = n.querySelector('[data-boost-notif-price]');
    var compare = n.querySelector('[data-boost-notif-compare]');
    var qtyEl = n.querySelector('[data-boost-notif-qty]');
    var variant = n.querySelector('[data-boost-notif-variant]');
    var more = n.querySelector('[data-boost-notif-more]');

    // Image : priorité au visuel de l'offre, sinon celui de la ligne.
    var imgUrl = meta.image || it.image || (it.featured_image && it.featured_image.url) || '';
    if (img) {
      if (imgUrl) {
        img.src = imgUrl.indexOf('?') === -1 ? imgUrl + '?width=200' : imgUrl;
        img.alt = meta.title || it.product_title || it.title || '';
        img.parentElement.hidden = false;
      } else {
        img.removeAttribute('src');
        img.parentElement.hidden = true;
      }
    }

    // Libellé de l'offre choisie ("2 ACHETER = 1 OFFERT !").
    if (offer) {
      if (meta.title) { offer.textContent = meta.title; offer.hidden = false; }
      else offer.hidden = true;
    }

    // Nom du produit réel (toujours affiché).
    if (title) title.textContent = it.product_title || it.title || '';

    // Prix : priorité au prix AFFICHÉ de l'offre. La remise (code/auto) n'est
    // pas encore chiffrée sur la ligne à l'ajout -> le total de ligne brut
    // serait faux pour une offre. Replis : total de ligne réel, puis unitaire.
    if (price) {
      if (meta.price) { price.hidden = false; price.textContent = meta.price; }
      else {
        var cents = lineTotalOf(data);
        if (cents == null) cents = priceOf(it);
        if (cents == null) { price.hidden = true; }
        else { price.hidden = false; price.textContent = formatMoney(cents, n.dataset.moneyFormat); }
      }
    }

    // Prix barré (comparaison).
    if (compare) {
      if (meta.comparePrice) { compare.hidden = false; compare.textContent = meta.comparePrice; }
      else compare.hidden = true;
    }

    // Quantité réellement ajoutée (×N), masquée si une seule unité.
    if (qtyEl) {
      if (qty > 1) {
        qtyEl.hidden = false;
        qtyEl.textContent = (n.dataset.qtyText || '× [qty]').replace('[qty]', qty);
      } else qtyEl.hidden = true;
    }

    if (variant) {
      variant.textContent = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    }

    // "+ N autre(s) article(s)" : lignes DISTINCTES en plus (bundle multi-produits).
    if (more) {
      if (res.count > 1) {
        more.textContent = (n.dataset.moreText || '+ [count] autre(s) article(s)').replace('[count]', res.count - 1);
        more.hidden = false;
      } else {
        more.hidden = true;
      }
    }

    n.hidden = false;
    n.getBoundingClientRect(); // reflow : la transition part de l'état fermé
    n.classList.add('is-open');

    var delay = parseInt(n.dataset.autoclose, 10);
    clearTimeout(notifTimer);
    if (delay > 0) notifTimer = setTimeout(dismiss, delay * 1000);
    return true;
  }

  /* ---------- Comportement après ajout ---------- */

  function openDrawer(trigger) {
    var d = getDrawer();
    if (d && typeof d.open === 'function') { d.open(trigger); return true; }
    return false;
  }

  function afterAdd(data, meta) {
    var n = getNotif();
    var behavior = n ? (n.dataset.behavior || 'notification') : 'drawer';

    // 1) Immédiat : la notification et la pastille n'attendent pas le rendu du tiroir
    if (behavior === 'notification' || behavior === 'both') notify(data, meta);
    refreshCount();

    // 2) En arrière-plan : le contenu du tiroir
    var done = refresh();
    if (behavior === 'drawer' || behavior === 'both') {
      done.then(function () { openDrawer(); });
    }
  }

  /* ---------- Ajout au panier ---------- */

  function post(body, isFormData, trigger, fallbackUrl, meta) {
    var opts = {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    };

    // Pas de "sections" ici : on veut la réponse la plus rapide possible.
    if (isFormData) {
      opts.body = body;
    } else {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }

    if (trigger) { trigger.classList.add('is-loading'); trigger.setAttribute('aria-disabled', 'true'); }

    return fetch(addUrl() + '.js', opts)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Ajout impossible');
        }
        afterAdd(data, meta);
        return data;
      })
      .catch(function (err) {
        console.warn('[boost-cart] add error:', err);
        if (fallbackUrl) window.location = fallbackUrl;
        throw err;
      })
      .finally(function () {
        if (trigger) { trigger.classList.remove('is-loading'); trigger.removeAttribute('aria-disabled'); }
      });
  }

  /* ---------- API publique ---------- */

  window.BoostCart = {
    /**
     * Ajoute un ou plusieurs articles au panier.
     * @param {Object|Array} items  {id, quantity, selling_plan, properties} ou tableau
     * @param {Object} [opts]       { trigger: Element, code: 'CODEPROMO' }
     * @returns {Promise}
     */
    add: function (items, opts) {
      opts = opts || {};
      var list = Array.isArray(items) ? items : [items];
      var meta = opts.meta || null;

      // Avec un code de réduction : /discount/CODE pose un cookie de remise.
      // On le déclenche par un fetch silencieux -> pas de rechargement, la
      // notification s'affiche normalement. Repli sur la redirection si échec.
      // (Une REDUCTION AUTOMATIQUE reste plus simple : aucun code nécessaire.)
      if (opts.code) {
        var root = (window.routes && window.routes.root_url) || '/';
        if (root.slice(-1) !== '/') root += '/';
        var codeUrl = root + 'discount/' + encodeURIComponent(opts.code);

        // /discount/CODE renvoie une page HTML complète (~1s). Le cookie de
        // remise est indépendant des lignes du panier : on le pose EN PARALLELE
        // de l'ajout au lieu d'attendre. La notification reste instantanée.
        fetch(codeUrl, { method: 'GET', credentials: 'same-origin' })
          .catch(function () { /* non bloquant */ });

        return post({ items: list }, false, opts.trigger, opts.fallbackUrl || cartUrl(), meta);
      }

      return post({ items: list }, false, opts.trigger, opts.fallbackUrl || cartUrl(), meta);
    },
    refresh: refresh,
    refreshCount: refreshCount,
    open: function (trigger) { return openDrawer(trigger); },
    close: function () { var d = getDrawer(); if (d && d.close) d.close(); },
    notify: notify,
    dismiss: dismiss,
    formatMoney: formatMoney
  };

  /* ---------- Écouteurs de la notification ---------- */

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-boost-notif-close]')) {
      e.preventDefault();
      dismiss();
      return;
    }
    var cartBtn = e.target.closest && e.target.closest('[data-boost-notif-cart]');
    if (cartBtn) {
      e.preventDefault();
      dismiss();
      setTimeout(function () { if (!openDrawer()) window.location = cartUrl(); }, 220);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') dismiss();
  });

  /* ---------- Démarrage ---------- */

  function boot() {
    ensureCartIconBubble();

    // Retour depuis une URL /discount/CODE (repli) : on rouvre le tiroir
    var flag = null;
    try { flag = sessionStorage.getItem('boostCartReopen'); } catch (e) {}
    if (flag) {
      try { sessionStorage.removeItem('boostCartReopen'); } catch (e) {}
      setTimeout(function () { openDrawer(); }, 350);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* ---------- Liens /cart et /cart/add ---------- */

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || link.hasAttribute('data-boost-no-drawer')) return;
    var href = link.getAttribute('href');
    if (!getDrawer()) return;

    if (isCartUrl(href)) {
      e.preventDefault();
      openDrawer(link);
      return;
    }

    if (isCartAddUrl(href)) {
      var u = parseUrl(href);
      var id = u.searchParams.get('id');
      if (!id) return;
      e.preventDefault();

      var payload = { id: Number(id), quantity: Number(u.searchParams.get('quantity') || 1) };
      var sp = u.searchParams.get('selling_plan');
      if (sp) payload.selling_plan = Number(sp);
      u.searchParams.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m) { payload.properties = payload.properties || {}; payload.properties[m[1]] = val; }
      });

      window.BoostCart.add(payload, { trigger: link }).catch(function () {});
    }
  }, false);

  /* ---------- Formulaires d'ajout ---------- */

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return; // le thème de base gère déjà ce formulaire

    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-boost-no-ajax')) return;
    if (!getDrawer()) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]') || form.querySelector('.boost-upsell__add');
    post(new FormData(form), true, btn, cartUrl()).catch(function () {});
  }, false);
})();